import React from 'react';

const PortfolioContact = () => {
  return (
    <div className="PortfolioOutro-contact">
      <div>
        <div className="Content Content--information">
          <p>
            +44 (0)20 7254 7462
            <br />
            <a
              href="https://www.instagram.com/villagegreen.studio/"
              target="_blank"
              rel="noopener noreferrer"
            >
              @villagegreen.studio
            </a>
          </p>
        </div>
      </div>
      <div>
        <div className="Content Content--information">
          <p>
            15 Sheep Lane
            <br />
            London, E8 3FA
          </p>
        </div>
      </div>
    </div>
  );
};

export default PortfolioContact;



// WEBPACK FOOTER //
// ./src/js/components/PortfolioContact.jsx